/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
/**
 * Provides all nessesary aria-* attributes to create valid pressed button states
 * https://sarahmhigley.com/writing/playing-with-state/
 */
export function ariaPressed() {
    return (target) => target.addInitializer((instance) => new AriaPressedController(instance));
}
export class AriaPressedController {
    constructor(host) {
        this.host = host;
        this.host.addController(this);
    }
    hostUpdated() {
        if (this.host.pressed !== null && this.host.pressed !== undefined) {
            this.host.ariaPressed = this.host.pressed ? 'true' : 'false';
        }
        if (this.host.readonly) {
            this.host.ariaPressed = null;
        }
    }
}
